module.exports = __webpack_public_path__ + "static/media/tom2.390ac7fc.wav";